import PropTypes from 'prop-types'
import React from 'react'
import { Button } from './Button'

export function RowExpand({
  label,
  controls,
  compact = false,
  expanded,
  onChange,
}) {
  return (
    <Button
      className={`me-btn-icon me-btn-row-expand me-btn-icon-${
        compact ? 'xs' : 'sm'
      }`}
      icon="fa-regular fa-chevron-right"
      aria-label={window.MEButtons.text('strRowDetails', { label })}
      data-row-expand=""
      aria-controls={controls}
      aria-expanded={expanded}
      onClick={() => {
        onChange(!expanded)
      }}
    />
  )
}

RowExpand.propTypes = {
  // The row's name; the button reads "<label> details".
  label: PropTypes.string.isRequired,
  // The id of the detail region the button shows and hides.
  controls: PropTypes.string.isRequired,
  compact: PropTypes.bool,
  expanded: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
}
